import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const loadView = function(view, path = '') {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views${path}/${view}.vue`)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: loadView('index')
    },
    {
      path: '/cart',
      name: 'cart',
      component: loadView('cart')
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: loadView('checkout')
    },
    {
      path: '/contact',
      name: 'contact',
      component: loadView('contact')
    },
    {
      path: '/faq',
      name: 'faq',
      component: loadView('faq')
    },
    {
      path: '/success',
      name: 'success',
      component: loadView('success')
    },
    {
      path: '/unsubscribe',
      name: 'unsubscribe',
      component: loadView('unsubscribe')
    },
    {
      path: '/products/:id',
      name: 'product-detail',
      component: loadView('detail', '/products')
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  // we statically load in old data from the DB, but we make a call on first page
  // to fetch the products so that we can get accurate inventory info. this allows
  // us to have a faster first page load but still get up-to-date quantities
  if (store.state.initialized === false) {
    store.dispatch('fetchProducts')
  }
  next()
})

export default router